"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateMaturityDate = exports.generateInitialTargetFundingDate = void 0;
const common_1 = require("@finley-technologies/common");
const generateFundingDate = ({ requestTimestamp = new Date(), // Default to current day (NOTE: server side system default is Eastern Time)
configuration: { offset }, }) => {
    (0, common_1.finleyAssert)(offset.count >= 0, `Target funding generator requires an offset that is greater than or equal to 0 days.`);
    let targetFundingDate;
    switch (offset.unit) {
        case 'businessDay': {
            const currentDateTime = common_1.date.epochMsToDateTime(requestTimestamp.getTime());
            // LOGIC COPIED FROM FUNDING REQUEST V1
            let _currentDateTime = currentDateTime.setZone('America/New_York');
            // if its past 5pm ET, set the "currentDate" to next day for evaluation
            if (_currentDateTime.hour >= common_1.consts.closeOfBusinessHour) {
                _currentDateTime = currentDateTime.plus({ days: 1 });
            }
            const currentDate = _currentDateTime.toISODate();
            // if expireDaysOffset === 0, and currentDate is not a bizDay, this may return a day in the past
            targetFundingDate = common_1.date.addBusinessDays(currentDate, offset.count);
            if (common_1.date.diffDays(targetFundingDate, currentDate) < 0) {
                targetFundingDate = common_1.date.addBusinessDays(targetFundingDate, 1);
            }
            break;
        }
        default:
            return (0, common_1.finleyAssertUnreachable)(offset.unit);
    }
    return targetFundingDate;
};
const generateInitialTargetFundingDate = (params) => {
    const { postingDate, targetFundingDate, maturityDate } = params;
    if (postingDate)
        return postingDate;
    if (targetFundingDate)
        return targetFundingDate;
    let fundingDateInput = new Date();
    if (maturityDate) {
        const preMaturityDate = common_1.date.fullDateStrToDate(common_1.date.addDays(maturityDate, -3));
        if (preMaturityDate < fundingDateInput) {
            fundingDateInput = preMaturityDate;
        }
    }
    const fundingDate = generateFundingDate({
        requestTimestamp: fundingDateInput,
        configuration: { offset: { count: 0, unit: 'businessDay' } },
    });
    return fundingDate;
};
exports.generateInitialTargetFundingDate = generateInitialTargetFundingDate;
const generateMaturityDate = ({ fundingDate, term, count, }) => {
    let maturityDate;
    switch (term) {
        case 'months':
            maturityDate = common_1.date.addMonths(fundingDate, count);
            break;
        default:
            return (0, common_1.finleyAssertUnreachable)(term);
    }
    // Current date logic will roll back to last known business day when adding 0 business days
    const lastKnownBusinessDay = common_1.date.addBusinessDays(maturityDate, 0);
    // If the last known business day does not match maturity date, roll forward to 1 new business day
    // Roll forward instead of cutting off early to avoid shortening the period of the loan
    // Example: maturity lands on Saturday, roll forward to Monday instead of leaving it on Friday
    // User can always adjust the date in the request form if desired
    if (lastKnownBusinessDay !== maturityDate) {
        return common_1.date.addBusinessDays(lastKnownBusinessDay, 1);
    }
    // Otherwise if matching, return the calculated maturity date
    return maturityDate;
};
exports.generateMaturityDate = generateMaturityDate;
//# sourceMappingURL=dates.js.map